import { Link } from 'react-router-dom';
import { groupLegalBlocks, linkifyLegalText } from '../types/legal';
import type { LegalDocumentMeta } from '../types/legal';

type LegalDocumentProps = {
  document: LegalDocumentMeta;
};

function RenderText({ text }: { text: string }) {
  const parts = linkifyLegalText(text);
  return (
    <>
      {parts.map((part, index) =>
        part.type === 'link' ? (
          <a key={`${part.href}-${index}`} href={part.href}>
            {part.value}
          </a>
        ) : (
          <span key={index}>{part.value}</span>
        ),
      )}
    </>
  );
}

export default function LegalDocument({ document }: LegalDocumentProps) {
  const groups = groupLegalBlocks(document.blocks);

  return (
    <div className="container legal-page">
      <nav className="legal-breadcrumb">
        <Link to="/">Ana Sayfa</Link>
        <span>/</span>
        <span>{document.title}</span>
      </nav>

      <header className="legal-header">
        <h1>{document.title}</h1>
        <p>{document.description}</p>
      </header>

      <article className="legal-content">
        {groups.map((group, index) => {
          if (group.type === 'heading') {
            if (group.level === 'h1') {
              return (
                <h2 key={`${group.text}-${index}`} className="legal-doc-title">
                  {group.text}
                </h2>
              );
            }
            if (group.level === 'h2') {
              return (
                <h2 key={`${group.text}-${index}`} className="legal-section-title">
                  {group.text}
                </h2>
              );
            }
            return (
              <h3 key={`${group.text}-${index}`} className="legal-subsection-title">
                {group.text}
              </h3>
            );
          }

          if (group.type === 'list') {
            return (
              <ul key={`list-${index}`} className="legal-list">
                {group.items.map((item) => (
                  <li key={item}>
                    <RenderText text={item} />
                  </li>
                ))}
              </ul>
            );
          }

          return (
            <p key={`${group.text.slice(0, 24)}-${index}`}>
              <RenderText text={group.text} />
            </p>
          );
        })}
      </article>
    </div>
  );
}
